var map = {
	"./DROP_DOWN.svg": 532,
	"./ic_arbitrum_16.svg": 870,
	"./ic_avalanche_16.svg": 871,
	"./ic_avax_40.svg": 872,
	"./ic_bnb_40.svg": 873,
	"./ic_btc_40.svg": 874,
	"./ic_coingecko_16.svg": 875,
	"./ic_convert_down.svg": 876,
	"./ic_copy_16.svg": 877,
	"./ic_eth_40.svg": 627,
	"./ic_frax_40.svg": 878,
	"./ic_glp_24.svg": 879,
	"./ic_glp_40.svg": 880,
	"./ic_link_40.svg": 881,
	"./ic_metamask_16.svg": 882,
	"./ic_mim_40.svg": 883,
	"./ic_new_link_16.svg": 884,
	"./ic_settings_16.svg": 885,
	"./ic_sign in_16.svg": 886,
	"./ic_sign_out_16.svg": 887,
	"./ic_uni_40.svg": 888,
	"./ic_usdc.e_40.svg": 889,
	"./ic_usdc_40.svg": 890,
	"./ic_usdt_40.svg": 891,
	"./ic_wavax_40.svg": 892,
	"./ic_wbnb_40.svg": 893,
	"./ic_weth_40.svg": 894,
	"./lever.svg": 895,
	"./long.svg": 896,
	"./short.svg": 897,
	"./swap.svg": 898,
	"./swapup.svg": 899,
	"./wave-01.png": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 869;